<template>
  <div id="CardHoddy">
    <shop-header :path="path" :headerTitle="childmsg" :isPath="isPath" :style="!closeQR?'padding-top:48px':''"></shop-header>
    <router-view></router-view>
    <shop-footer />
    <div id="ScrollAll" v-if="istop">
      <div class="scrollUp" @click="scrollBox(0)"><i class="el-icon-arrow-up"></i></div>
      <div class="scrollDown" @click="scrollBox(1)"><i class="el-icon-arrow-down"></i></div>
    </div>
    <div class="QRFoot" v-if="!closeQR">
      <div class="QRFootBox">
        <span>{{$t('base.collectLoveTrade')}}</span>
        <span @click="showQRcode">{{$t('base.getApp')}}</span>
        <i @click="closeQRcode(1)"></i>
      </div>
    </div>
    <get-contact :domVisible='dislogType.contact' />
  </div>
</template>
<script>
import ShopHeader from './header'
import bus from '@/api/bus';
import ShopFooter from './footer.vue'
import GetContact from "@/components/dialog/contact"; // 联系客服
import VueCookie from "vue-cookie";
export default {
  name: 'layout',
  components: {
    ShopHeader,
    ShopFooter,
    GetContact
  },
  data() {
    return {
      path: [],
      childmsg: "",
      isPath: true,
      istop: false,
      closeQR:true,
      dislogType: this.$enumInfo.dislogType,
    }
  },
  watch: {
    '$route': 'getPath'
  },
  mounted() {
    this.Layout();
    this.closeQRcode(0)
    var that = this
    this.$root.$on("contactUS", val => {
      this.dislogType.contact=val
    })
    window.addEventListener('scroll', function() {
      if (document.documentElement.scrollTop > 1500) {
        that.istop = true
      } else {
        that.istop = false
      }
    })
  },
  created() {
    bus.$on('headerTitle', (val) => {
      this.childmsg = val;
    });
  },
  methods: {
    getPath() {
      this.Layout();
    },
    // 滚动 0：滚到顶部，1：滚到底部
    scrollBox(val) {
      if (val != 1) {
        let top = document.documentElement.scrollTop;
        // 实现滚动效果 
        const timeTop = setInterval(() => {
          document.documentElement.scrollTop = (top -= 50);
          if (top <= 0) {
            clearInterval(timeTop); //清除定时器
          }
        }, 0);
      } else {
        let hi = document.documentElement.scrollHeight
        let top = document.documentElement.scrollTop;
        //console.log(hi, 'abc')
        //实现滚动效果 
        const timeDown = setInterval(() => {
          document.documentElement.scrollTop = (top += 50);
          //console.log(top, hi, 'abc')
          if (top >= hi) {
            clearInterval(timeDown); //清除定时器
          }
        }, 0);
      }
    },
    Layout() {
      this.path = this.$route.path.slice(1).split("/");
     const router=["pay","mycardhobby","messages","terms","feedback"]
      if (router.indexOf(this.path[0])>-1) {
        this.isPath = false
      } else {
        this.isPath = true
      }
    },
    showQRcode(){
      // window.sessionStorage.setItem('check', JSON.stringify(data))
      let html='<div class="QRcodePro">'
      +'<div class="title">'+this.$t('alert.downloadApp')+'</div>'
      +'<img src='+(process.env.NODE_ENV === 'production'?'../../../static/images/QRcode_pro.png':'../../../static/images/QRcode_test.png')+' />'
      +'<div class="openCamera">'+this.$t('alert.openCamera')+'</div>'
      +'</div>'
      this.$alert(html, '', {
            customClass: "confirmBox",
            lockScroll: false,
            showConfirmButton:false,
            dangerouslyUseHTMLString: true,
            callback: action => {}
          });
    },
    //关闭底部提示条 0:判断是否已经关闭，1:关闭
    closeQRcode(val){
      if(val==0){
        this.closeQR=VueCookie.get("QrPRo")!=1?false:true
      }else{
        VueCookie.set('QrPRo', 1)
        this.closeQR=true
      }
      
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout.vue